import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";

const RegistrationForm = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(true);
  const navigate = useNavigate();

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setPasswordMatch(password === e.target.value);
  };

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  return (
    <div>
      <Header />
      <div className="container-fluid d-flex justify-content-center align-items-center vh-100 mt-5" style={{ backgroundColor: "#ffff" }}>
        <div className="row shadow-lg w-75">
          {/* Left Section */}
          <div className="col-md-6 p-5 text-white" style={{ backgroundColor: "#1a237e" }}>
            <h3>INFORMATION</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
              euismod, nunc et fermentum posuere, sapien nisi consequat purus.
            </p>
            <button className="btn btn-light" onClick={handleLoginRedirect}>Have An Account</button>
          </div>

          {/* Right Section */}
          <div className="col-md-6 p-5 bg-white">
            <h3 className="mb-4">REGISTER FORM</h3>
            <form>
              <div className="mb-3">
                <label className="form-label">First Name</label>
                <input type="text" className="form-control" placeholder="First Name" />
              </div>
              <div className="mb-3">
                <label className="form-label">Last Name</label>
                <input type="text" className="form-control" placeholder="Last Name" />
              </div>
              <div className="mb-3">
                <label className="form-label">Your Email</label>
                <input type="email" className="form-control" placeholder="Your Email" />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className={`form-control ${passwordMatch ? "" : "is-invalid"}`}
                  placeholder="Password"
                  value={password}
                  onChange={handlePasswordChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Confirm Password</label>
                <input
                  type="password"
                  className={`form-control ${passwordMatch ? "" : "is-invalid"}`}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                />
                {!passwordMatch && <div className="text-danger">Passwords do not match</div>}
              </div>
              <div className="form-check mb-3">
                <input type="checkbox" className="form-check-input" id="terms" />
                <label className="form-check-label" htmlFor="terms">
                  I agree to the <a href="#">Terms and Conditions</a>
                </label>
              </div>
              <button type="submit" className="btn btn-primary w-100">Register</button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RegistrationForm;
